import { render } from "./ElementView.vue?vue&type=template&id=5de238c8&ts=true"
import script from "./ElementView.vue?vue&type=script&lang=ts"
export * from "./ElementView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__